<template>
	<div class="bgWhite p10" style="min-height: 390px;">
		<h4 style="margin-bottom: 10px;"><img src="../assets/images/kxph.png" alt=""></h4>
		<div class="mw-ranking">
			<div class="mw-ranking-list" v-for="(item, index) in record_list" :key="index">
				<div> <span :class="{ 'mw-ranking-index-top': index < 3, 'mw-ranking-index': index >= 3 }">{{ index + 1 }}</span> </div>
				<div>
					<router-link :to="'/home/inforDetail/' + item.primary_id">{{ item.the_title }}</router-link>
				</div>
			</div>
			<div class="fast-news-ad" style="margin: 10px 0;" v-if="ad">
				<a :href="link ? link : ''" target="_blank" rel="">
					<img :src="ad ? ad : defaultAd" alt="" style="height: 80px;" class="w100">
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	import $ from 'jquery'
	import { baseUrl } from '../assets/js/common';
	export default {
		name: 'HotRecord',
		components: {},
		props: {
			ad: String,
			link: String
		},
		data() {
			return {
				defaultAd: '', //
				record_list: []
			}
		},
		mounted() {
			// 初始化内容
			this.tNewsConsultSelTop();
		},
		methods: {
			//页面操作
			// 获取数据 /api_v3/t_news_consult_sel_top
			tNewsConsultSelTop() {
				const self = this;
				const dates = new self.getDates();
				$.ajax({
					url: `${baseUrl.service}/api_v3/t_news_consult_sel_top?sdate=${dates.sdate}&edate=${dates.edate}`,
					data: {},
					type: 'get',
					dataType: 'json',
					success: (res) => {
						if(res.code == 'ok') {
							self.record_list = res.data
						} else {
							self.$message.error(res.message);
						}
					},
					error: () => {
						self.$message.error('未获取到24小时热榜信息')
					}
				})
			},

			getDates() {
				function GetDateStr (AddDayCount) {    
					var dd = new Date();
					dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
					var y = dd.getFullYear();
					var m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1); //获取当前月份的日期，不足10补0
					var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
					return y + "-" + m + "-" + d;
				}
				return {
					sdate: GetDateStr(-30),
					edate: GetDateStr(0)
				}
			},
			
		},
	}
</script>

<style scoped>

</style>